<template>
    <img class="icon" :class="'icon-' + name" :src="file" :alt="alt" />
</template>

<script lang="ts" setup>
import { useImageLoad } from '@btcdirect/shared/src/composables/image-load';
import { computed } from 'vue';

const props = defineProps({
    name: {
        type: String,
        required: true
    },
    directory: {
        type: String,
        required: false,
        default: ''
    },
    alt: {
        type: String,
        required: false,
        default: ''
    },
    extension: {
        type: String,
        required: false,
        default: 'svg'
    }
});

const { get } = useImageLoad();

const file = computed<string>(() => get(props.name, props.directory, props.extension));
</script>

<style lang="scss">
.illustration {
    align-self: center;
    width: 9.75em;
}
</style>
